import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import { IconWhatsapp } from '../atoms/Icon';
import { contato, linkWhatsapp } from '../content/site';
import { trackEvent } from '../utils/analytics';

const ANO = new Date().getFullYear();

/** Só fechamento, não navegação: a coluna "A página" duplicava o menu do
 *  header sem servir a ninguém que já rolou até aqui, e o Instagram não é
 *  canal de atendimento — some com ela. Sobram marca e contato, um de cada
 *  lado, sem coluna vazia sobrando no meio. */
function SiteFooter() {
  return (
    <footer className="lp-footer on-purple">
      <Container className="shell">
        <Row className="g-4 justify-content-between">
          <Col md={6} lg={5}>
            <img src="/images/icon-horizontal.png" alt="MyPedidos" className="lp-footer-logo" />
            <p style={{ maxWidth: '26rem' }}>
              Cardápio digital com link próprio, pedido pronto no WhatsApp e um painel para
              acompanhar do pagamento até o pronto.
            </p>
          </Col>

          <Col md={5} lg={4}>
            <div className="lp-footer-title">Falar com a gente</div>
            <ul className="lp-footer-list">
              <li>
                <a
                  href={linkWhatsapp}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="d-inline-flex align-items-center gap-2"
                  onClick={() => trackEvent('click_whatsapp', { posicao: 'rodape' })}
                >
                  <IconWhatsapp size={15} />
                  WhatsApp
                </a>
              </li>
              <li>
                <a
                  href={`mailto:${contato.email}`}
                  onClick={() => trackEvent('click_email', { posicao: 'rodape' })}
                >
                  {contato.email}
                </a>
              </li>
            </ul>
          </Col>
        </Row>

        <div className="lp-footer-bottom d-flex flex-wrap justify-content-between gap-2">
          <span>© {ANO} MyPedidos. Todos os direitos reservados.</span>
          <span>Feito para quem vende comida.</span>
        </div>
      </Container>
    </footer>
  );
}

export default SiteFooter;
